export default __webpack_public_path__ + "static/media/Legend of Shevatas.22e76788.jpg";